<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useAbility } from "@casl/vue";
import { definePage } from "unplugin-vue-router/runtime";
import MsoPersonsSection from "@/components/models/practice/detail/MsoPersonsSection.vue";
import { useMso } from "@/composables/models/practice/useMsos";

definePage({
  meta: {
    title: "generic.fields.sections.persons",
    checkPrivileges: () => {
      const { can } = useAbility();
      return (
        can($permActions.READ, $permSubjects.PRACTICE__MSO) &&
        can($permActions.READ, $permSubjects.PRACTICE__PRACTICESTAFF)
      );
    },
  },
});

const route = useRoute();
const msoId = computed(() => (route.params as { id: string }).id);
const { data: mso, isLoading } = useMso({ id: msoId.value });
</script>

<template>
  <div class="tw:flex tw:flex-col tw:gap-5 tw:pb-4! tw:sm:pb-6!">
    <v-skeleton-loader
      :loading="isLoading"
      type="heading,card"
    >
      <mso-persons-section :mso="mso" />
    </v-skeleton-loader>
  </div>
</template>
